import { Fragment } from "react";
import NavigationBar from "./components/Navigation/NavigationBar";
import Footer from "./components/Footer/Footer";
import "./App.css";

const Layout = (props) => {
    const works = { 0: { name: "EduMetrics Pro", link: "project/EduMetrics Pro" }, 1: { name: "Space Shooter", link: "project/Space%20Shooter" }, };
    return (
        <Fragment>
            <NavigationBar />
            <div className="layout">
                {props.children}
            </div>
            <Footer topWorks={works} />

        </Fragment>
    );
}

export default Layout;
